import { call, put, takeLatest } from "redux-saga/effects";
import kotApi from "api/kotApi";
import { kotActions } from "./kotSlice";
import { toast } from "react-toastify";

function* getKotConfigsSaga(action: any): Generator<any, void, any> {
  try {
    const response = yield call(kotApi.getKotConfigs, action.payload);
    yield put(kotActions.getKotConfigsSuccess(response?.data || response));
  } catch (err: any) {
    const msg = err?.response?.data?.message || "Failed to fetch KOT configs";
    yield put(kotActions.getKotConfigsFail(msg));
    toast.error(msg);
  }
}

function* saveKotConfigSaga(action: any): Generator<any, void, any> {
  try {
    const response = yield call(kotApi.addOrUpdateKotConfig, action.payload);
    const msg = response?.data?.message || "Saved successfully";
    yield put(kotActions.saveKotConfigSuccess(msg));
    toast.success(msg);
  } catch (err: any) {
    const msg = err?.response?.data?.message || "Failed to save KOT config";
    yield put(kotActions.saveKotConfigFail(msg));
    toast.error(msg);
  }
}

function* deleteKotConfigSaga(action: any): Generator<any, void, any> {
  try {
    const response = yield call(kotApi.deleteKotConfig, action.payload);
    const msg = response?.data?.message || "Deleted successfully";
    yield put(kotActions.deleteKotConfigSuccess(msg));
    toast.success(msg);
  } catch (err: any) {
    const msg = err?.response?.data?.message || "Failed to delete KOT config";
    yield put(kotActions.deleteKotConfigFail(msg));
    toast.error(msg);
  }
}

export function* kotSaga() {
  yield takeLatest(kotActions.getKotConfigs.type, getKotConfigsSaga);
  yield takeLatest(kotActions.saveKotConfig.type, saveKotConfigSaga);
  yield takeLatest(kotActions.deleteKotConfig.type, deleteKotConfigSaga);
}
